// All rxjs observable operators and static methods should be imported here - never import the entire library as it is huge.
import { map, filter, startWith, tap, mergeMap, catchError, take, publishReplay } from 'rxjs/operators';
import { of, throwError, combineLatest, forkJoin } from 'rxjs';
